package com.example.mystybag.login.model

import com.example.mystybag.sharedmodels.project.responseModels.CityResponseModel

data class ChooseCityUIState(
    val cities: List<CityResponseModel> = emptyList(),
    val selectedCity: CityResponseModel? = null,
    val isLoading: Boolean = false,
    val searchText: String = ""
)

